var _path, _path2, _circle, _path3, _circle2, _path4, _ellipse, _path5, _circle3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancerNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 175,
    viewBox: "0 0 180 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.645 153.606C91.126 155.125 88.6631 155.125 87.144 153.606L79.1073 145.573C57.6092 124.085 57.6093 89.2467 79.1073 67.7588L104.653 42.2251C118.381 28.5038 140.638 28.5038 154.366 42.2251C168.094 55.9465 168.094 78.1932 154.366 91.9145L92.645 153.606Z",
    fill: "#D4DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3647 153.606C88.8838 155.125 91.3467 155.125 92.8657 153.606L100.902 145.573C122.401 124.085 122.401 89.2467 100.902 67.7588L75.3567 42.2251C61.6289 28.5038 39.3717 28.5038 25.6438 42.2251C11.916 55.9465 11.916 78.1932 25.6438 91.9145L87.3647 153.606Z",
    fill: "#D4DBE9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.623,
    cy: 77.7479,
    r: 21.3778,
    fill: "#E9EDF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.312 174.862H128.317C109.415 174.862 94.0918 159.539 94.0918 140.638V134.023C94.0918 118.774 106.453 106.413 121.702 106.413C136.95 106.413 149.312 118.774 149.312 134.023V174.862Z",
    fill: "#E9EDF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.623,
    cy: 77.7489,
    r: 21.3778,
    fill: "#007580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.312 167.033C149.312 171.358 145.805 174.864 141.48 174.864H128.317C109.415 174.864 94.0918 159.541 94.0918 140.64V134.025C94.0918 118.776 106.453 106.415 121.702 106.415C136.95 106.415 149.312 118.776 149.312 134.025V167.033Z",
    fill: "#007580"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9553,
    cy: 15.2429,
    rx: 14.9553,
    ry: 15.2429,
    transform: "matrix(-1 0 0 1 64.1816 68.4512)",
    fill: "#FF7F50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6689 146.883C29.6689 149.947 32.1526 152.431 35.2164 152.431H44.3367C57.838 152.431 68.7829 141.486 68.7829 127.984V123.095C68.7829 112.294 60.027 103.538 49.2259 103.538C38.4249 103.538 29.6689 112.294 29.6689 123.095V146.883Z",
    fill: "#FF7F50"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.119,
    cy: 18.119,
    r: 18.119,
    transform: "matrix(-1 0 0 1 95.2432 74.7783)",
    fill: "#284993"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8281 168.256C53.8281 171.906 56.7866 174.864 60.4361 174.864H71.3719C87.4146 174.864 100.42 161.859 100.42 145.816V140.064C100.42 127.198 89.9899 116.769 77.1239 116.769C64.258 116.769 53.8281 127.198 53.8281 140.064V168.256Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerNavigation);
export default __webpack_public_path__ + "static/media/CancerNavigation.7284a09777cccd4324316606011af014.svg";
export { ForwardRef as ReactComponent };